const config = {
    httpPrefix: 'https://',
    platformAddress: 'https://trial.opendatasoft.com',
    trialSubdomainSuffix: '.trial.opendatasoft.com',
};

export default config;
